<script>
import { mapState } from "vuex";
import router from "../../router/routes";
import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";

export default {
  components: { NavBar, SideBar, Footer },
  beforeCreate: function() {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false,
      modal: false,
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  mounted() {
    if (!this.$route.path.includes('/store/order')) {
      if (
        this.$store.state.account.user.membership &&
        this.$store.state.account.user.membership.status &&
        this.$store.state.account.user.membership.status == 'pending' &&
        this.$store.state.account.user.membership.order &&
        this.$store.state.account.user.membership.order.id
      ) {
        this.modal = false;
        this.modal = true;
      }
    }
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    }
  }
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" />
    <SideBar :isCondensed="isMenuCondensed" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>

    <b-modal v-if="account.user && account.user.membership && account.user.membership.order" v-model="modal" modal-class="modal-center" centered hide-header hide-footer>
      <div>
        <h4 class="mb-0">Sua mensalidade está pendente!</h4>
        <p class="mb-4">Clique abaixo para realizar o pagamento.</p>
        <router-link class="btn btn-default btn-lg btn-block mb-3" tag="a" :to="'/store/order/' + account.user.membership.order.id">
          Realizar pagamento
        </router-link>
        <button class="btn btn-outline-default btn-lg btn-block" v-on:click="modal = false">
          Fechar
        </button>
      </div>
    </b-modal>
  </div>
</template>
